<template>
 <svg 
  version="1.1" 
  id="Capa_1" 
  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  :width="width"
  :height="height"
  :aria-labelledby="iconName"
  viewBox="0 0 226.696 226.696" style="enable-background:new 0 0 226.696 226.696;" xml:space="preserve">
<g :fill="iconColor">
	<path d="M197.328,23.988h-16.475V7.5c0-2.205-0.97-4.297-2.652-5.723c-1.682-1.425-3.908-2.038-6.08-1.675L28.136,24.09
		c-3.617,0.603-6.268,3.731-6.268,7.398v187.708c0,4.142,3.358,7.5,7.5,7.5h167.959c4.143,0,7.5-3.358,7.5-7.5V31.488
		C204.828,27.346,201.47,23.988,197.328,23.988z M36.869,37.842l128.984-21.489v172.513L36.869,210.344V37.842z M189.828,211.696
		h-69.757l54.514-9.078c3.617-0.602,6.269-3.731,6.269-7.398V38.988h8.975V211.696z"/>
	<path d="M138.954,50.003l-77.484,12c-4.093,0.634-6.897,4.466-6.264,8.559c0.574,3.705,3.767,6.353,7.402,6.353
		c0.381,0,0.769-0.029,1.157-0.089l77.483-12c4.094-0.634,6.898-4.466,6.265-8.56C146.879,52.174,143.048,49.369,138.954,50.003z"/>
</g>
<g :fill="iconColor">
</g>
<g :fill="iconColor">
</g>
<g :fill="iconColor">
</g>
<g :fill="iconColor">
</g>
<g :fill="iconColor">
</g>
<g :fill="iconColor">
</g>
<g :fill="iconColor">
</g>
<g :fill="iconColor">
</g>
<g :fill="iconColor">
</g>
<g :fill="iconColor">
</g>
<g :fill="iconColor">
</g>
<g :fill="iconColor">
</g>
<g :fill="iconColor">
</g>
<g :fill="iconColor">
</g>
<g :fill="iconColor">
</g>
</svg>
</template>

<style lang="scss">
  
</style>
<script>
  export default {
    name: "Book",
     props: {
    iconName: {
      type: String,
      default: 'Book'
    },
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
  }
</script>